import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { IServerResponse } from "app/interface";
import { map, switchMap } from "rxjs/operators";
import * as type from "./actionTypes";
import * as DocumentSignatureAction from "./actions";
import { DocumentSignatureService } from "./service";

@Injectable()
export class DocumentSignatureEffect {
  constructor(
    private action: Actions,
    private documentSignatureService: DocumentSignatureService
  ) {}

  GetDocumentSignatureList = createEffect(() =>
    this.action.pipe(
      ofType(type.GET_DOCUMENT_SIGNATURE_LIST),
      switchMap(() => this.documentSignatureService.getDocumentSignatureList()),
      map(
        (data: Array<any>) =>
          new DocumentSignatureAction.DocumentSignatureList(data)
      )
    )
  );

  AddDocumentSignature = createEffect(() =>
    this.action.pipe(
      ofType(type.SAVE_DOCUMENT_SIGNATURE),
      switchMap((data: any) =>
        this.documentSignatureService.saveDocumentSignatureList(data.payload)
      ),
      map(
        (data: any) =>
          new DocumentSignatureAction.SaveDocumentSignatureResp(data)
      )
    )
  );

  UpdateDocumentSignature = createEffect(() =>
    this.action.pipe(
      ofType(type.UPDATE_DOCUMENT_SIGNATURE),
      switchMap((data: any) =>
        this.documentSignatureService.updateDocumentSignature(data.payload)
      ),
      map(
        (data: IServerResponse) =>
          new DocumentSignatureAction.UpdateDocumentSignatureResponse(data)
      )
    )
  );

  DocumentSignatureById = createEffect(() =>
    this.action.pipe(
      ofType(type.SEARCH_DOCUMENT_SIGNATURE_BY_ID),
      switchMap((data: any) =>
        this.documentSignatureService.getDocumentSignatureById(data.payload)
      ),
      map(
        (data: Array<any>) =>
          new DocumentSignatureAction.DocumentSignatureById(data)
      )
    )
  );

  DeleteDocumentSignatureById = createEffect(() =>
    this.action.pipe(
      ofType(type.DELETE_DOCUMENT_SIGNATURE),
      switchMap((data: any) =>
        this.documentSignatureService.deleteDocumentSignature(data.payload)
      ),
      map(
        (data: any) =>
          new DocumentSignatureAction.DeleteDocumentSignatureResponse(data)
      )
    )
  );

  ResendDocumentSignatureById = createEffect(() =>
    this.action.pipe(
      ofType(type.RESEND_DOCUMENT_SIGNATURE),
      switchMap((data: any) =>
        this.documentSignatureService.resendDocumentSignatureList(data.payload)
      ),
      map(
        (data: any) =>
          new DocumentSignatureAction.ResendDocumentSignatureResponse(data)
      )
    )
  );

  SearchDocumentSignatureByFields = createEffect(() =>
    this.action.pipe(
      ofType(type.SEARCH_DOCUMENT_SIGNATURE_BY_FIELD),
      switchMap((data: any) =>
        this.documentSignatureService.searchDocumentSignatureByFields(
          data.payload
        )
      ),
      map(
        (data) => new DocumentSignatureAction.DocumentSignatureByFieldList(data)
      )
    )
  );

  RefreshSignatureStatus = createEffect(() =>
    this.action.pipe(
      ofType(type.REFRESH_SIGNATURE_STATUS),
      switchMap((data: any) =>
        this.documentSignatureService.refreshSignatureStatus(data.payload)
      ),
      map(
        (data: Array<any>) =>
          new DocumentSignatureAction.RefreshSignatureStatusResponse(data)
      )
    )
  );
}
